export default "/img/AI.8be658241c7bb6bed6cf4b90b5a43760.png";